import React, { useEffect, useState } from "react";
// import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { ToastContainer, toast } from "react-toastify";
// import configureStore from "./configureStore";
import AppNavigator from "../Navigation";
import { connect } from "react-redux";
import { getUnit } from "../containers/LoginContainer/actions";
// import { push } from "connected-react-router";
import { history } from "./configureStore";
// const { store, persistor, history } = configureStore();

function App(props) {
  const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  //   const fmsToken = localStorage.getItem("fmsToken");

  //   if (fmsUser && fmsToken) {
  //     props.getUnitAction(fmsUser?.society_name);
  //   } else {
  //     history.push("/login");
  //   }
  // }, []);

  useEffect(() => {
    const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
    const fmsToken = localStorage.getItem("fmsToken");

    const fetchData = async () => {
      if (fmsUser && fmsToken) {
        const result = await props.getUnitAction(fmsUser.society_name);
        console.log("Finished:", result);
      } else {
        history.push("/login");
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // wait before rendering page
  }

  return (
    // <Provider store={store}>
    <>
      <ToastContainer hideProgressBar={true} />
      <ConnectedRouter history={history}>
        <div>
          <AppNavigator />
        </div>
      </ConnectedRouter>
    </>
    // </Provider>
  );
}

// export default App;

// function bindAction(dispatch) {
//   return {
//     getUnitAction: (value) => {
//       dispatch(getUnit(value));
//     },
//   };
// }

function bindAction(dispatch) {
  return {
    getUnitAction: (society) =>
      new Promise((resolve) => {
        dispatch(getUnit({ society, resolve })); // pass resolve to saga
      }),
  };
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, bindAction)(App);
